import { Trans } from '@lingui/react/macro';
import { Card, Tab, Tabs, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useHistory } from 'react-router-dom';

import routesConstants from '../../../routes/routes.constants';
import { colors } from '../../../utils/theme';

import { Form } from './Form';

const useStyles = makeStyles(() => ({
  formSection: {
    height: 'min-content',
    minWidth: '450px',
    maxWidth: '567px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '72px 63px 51px',
  },
  tabs: {
    marginBottom: '48px',
  },
  selectedTab: {
    fontFamily: 'proxima-nova, sans-serif',
    color: colors.PRIMARY,
    fontSize: '24px',
  },
  tab: {
    fontFamily: 'proxima-nova, sans-serif',
    fontSize: '24px',
  },
  formTitle: {
    fontFamily: 'proxima-nova, sans-serif',
    marginBottom: '45px',
  },
  indicator: {
    backgroundColor: colors.PRIMARY,
    margin: 'auto',
  },
  testimonyCard: {
    width: '100%',
    padding: '18px 14px 14px',
    display: 'flex',
    justifyContent: 'flex-start',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
  },
  testimonyImage: {
    marginRight: '17px',
    width: '76px',
    height: '76px',
  },
  testimony: {
    fontFamily: 'proxima-nova, sans-serif',
    fontSize: '18px',
    color: colors.QUOTE,
  },
  testimonyQuote: {
    marginTop: '15px',
    fontFamily: 'proxima-nova, sans-serif',
    fontSize: '18px',
    textAlign: 'right',
  },
}));

export const FormSection = () => {
  const classes = useStyles();
  const history = useHistory();

  const changeTabHandler = (_: any, value: 'accessNow' | 'logIn') => {
    if (value === 'logIn') {
      history.push(routesConstants.LOGIN);
    }
  };

  return (
    <div className={classes.formSection}>
      <Typography variant="h5" className={classes.formTitle}>
        <Trans>
          Get complimentary access from Dentrix Detect AI to additional AI tools
          today - powered by VideaHealth
        </Trans>
      </Typography>
      <Tabs
        value="accessNow"
        onChange={changeTabHandler}
        className={classes.tabs}
        TabIndicatorProps={{ className: classes.indicator }}
      >
        <Tab
          label="Access Now"
          value="accessNow"
          className={classes.selectedTab}
        />

        <Tab label="Log In" value="logIn" className={classes.tab} />
      </Tabs>
      <Form />
      <Card className={classes.testimonyCard}>
        <img
          src="/assets/images/landingPage/drOlivia.png"
          alt=""
          className={classes.testimonyImage}
        />

        <div>
          <Typography className={classes.testimony}>
            <Trans>
              &quot;...It made diagnosing each image faster and easier. Occlusal
              caries can be hard to spot, and the AI helped me confirm some I
              may have missed. It is also a great help to our younger hygienists
              in building their confidence in diagnosing and spotting
              caries.&quot;
            </Trans>
          </Typography>
          <Typography className={classes.testimonyQuote}>
            - Dr. Olivia Paulsrud, DDS
          </Typography>
        </div>
      </Card>
    </div>
  );
};
